import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const list = css`
  margin-top: ${size[32]};
  display: flex;
  gap: ${size[16]};
  width: 100%;
  overflow-x: auto;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ${breakpoint.up('smMd')} {
    display: flex;
    gap: ${size[40]};
  }
`
